import md5 from "./md5"
import qs from 'qs/dist/qs'
import axios from "axios/dist/axios"
const secretKey = "iambabytreekey!@#$%^&*()";
const tools = {
    getSignuature(header, body) {
        let obj = Object.assign({}, header, body);
        let str = "";
        Object.keys(obj).sort().forEach(key => {
            str += key.toLowerCase() + "=" + obj[key];
        });
        str += secretKey;
        return md5(str);
    }
};
const _newXHR = axios.create({
    baseURL: '',
    timeout: 1000 * 10,
    headers: {
        common: {
            "Content-Type": "application/x-www-form-urlencoded",
            clientInfo: JSON.stringify({
                userType: 2,
                clientAppVersion: "1.9.8",
                clientVersion: "",
                latitude: "",
                longitude: "",
                nettype: "unknown",
                screenwidth: window.innerWidth || document.documentElement.clientWidth,
                screenheight: window.innerHeight || document.documentElement.clientHeight
            }),
            platform: "1",
            birthday: "",
            protocol: document.location.protocol === "https:" ? "https" : "http"
        }
    },
    transformRequest: [function (data) {
        return qs.stringify(data, {
            allowDots: true
        });
    }]
});
_newXHR.interceptors.request.use(function (config) {
    let timestamp = Date.parse(new Date()) / 1000;
    config.headers["timestamp"] = timestamp;
    config.headers["signature"] = tools.getSignuature({
        timestamp
    }, config.data);
    return config;
}, function (error) {
    return Promise.reject(error);
});
_newXHR.interceptors.response.use(res => {
    return res;
}, err => {
    return Promise.reject(err);
});
const w2aRequest = _newXHR;
export default w2aRequest;